import { createFileRoute } from '@tanstack/react-router';

import { agentNotesSearchSchema } from '@apps/web/features/admin_agent_notes/model/search_params';
import { NoteDetailPage } from '@apps/web/features/admin_agent_notes/ui/note_detail_page';

export const Route = createFileRoute('/_app/admin/agent-notes/$note-id')({
    validateSearch: agentNotesSearchSchema,
    head: () => ({
        meta: [
            {
                title: 'Agent Note | Phoebe Admin',
            },
        ],
    }),
    component: NoteDetailPage,
});
